export enum RouteNames {
    // General
    SSOLogin = 'sso-login',
    Login = 'login',
    LoginPassword = 'login-password',
    LoginSsoSelect = 'login-sso-select',
    LoginBankId = 'login-bankid',
    LoginChangePassword = 'login-change-password',
    SetPassword = 'set-password',
    VerifyEmail = 'verify-email',
    FortnoxAuth = 'fortnox-auth',
    MyUser = 'my-user',
    SelectRole = 'select-role',
    NoModuleAccess = 'no-module-access',

    // Manager
    ManagerJobArchitectureOverviewV2 = 'manager-job-architecture-overview-v2',
    ManagerExternalJobArchitectureOverviewV2 = 'manager-external-job-architecture-overview-v2',

    // ManagerV2
    ManagerDashboardV2 = 'manager-dashboard-v2',
    ManagerAnalysisV2 = 'manager-analysis-v2',
    ManagerDiscussions = 'manager-discussions',
    ManagerDiscussionEditOneOnOne = 'manager-discussion-edit-one-on-one',
    ManagerDiscussionEditGroup = 'manager-discussion-edit-group',
    ManagerDiscussionEmployment = 'manager-discussion-employment',
    ManagerTargets = 'manager-targets',

    ManagerCustomEmploymentDashboard = 'manager-custom-employment-dashboard',
    ManagerEmployeeDashboard = 'manager-employee-dashboard',
    ManagerDeaiEmploymentDashboard = 'manager-deai-employment-dashboard',

    ManagerEmployeeActivities = 'manager-employee-activities', // leave for now
    ManagerEmployeeDiscussions = 'manager-employee-discussions',
    ManagerEmployeeDiscussion = 'manager-employee-discussion',
    ManagerEmployeeTargets = 'manager-employee-targets',
    ManagerEmployeeAssessments = 'manager-employee-assessments',
    ManagerSalarySetDashboardV2 = 'manager-salary-set-dashboard-v2',
    ManagerSalarySetV2 = 'manager-salary-set-v2',
    ManagerSalaryReviewAssessmentDashboardV2 = 'manager-salary-review-assessment-dashboard-v2',
    ManagerSalaryReviewAssessmentV2 = 'manager-salary-review-assessment-v2',

    // PartnerPlatform
    PartnerPlatform = 'partner-platform',

    // Employee

    // EmployeeV2
    EmployeeCustomEmploymentDashboard = 'employee-custom-employment-dashboard',
    EmployeeDashboard = 'employee-dashboard',
    EmployeeDeaiEmploymentDashboard = 'employee-deai-employment-dashboard',

    Employee = 'employee',
    EmployeeDashboardV2 = 'employee-dashboard-v2',
    EmployeeActivities = 'employee-activities', // leave for now
    EmployeeDiscussions = 'employee-discussions',
    EmployeeDiscussion = 'employee-discussion',
    EmployeeTargets = 'employee-targets',
    EmployeeAssessments = 'employee-assessments',

    // SectionManager
    SectionManagerStart = 'section-manager-start',
    SectionManagerSalarySetDashboard = 'section-manager-salary-set-dashboard',
    SectionManagerJobArchitectureOverview = 'section-manager-job-architecture-overview',
    SectionManagerExternalJobArchitectureOverview = 'section-manager-external-job-architecture-overview',
    SectionManagerSalarySet = 'section-manager-salary-set',
    SectionManagerDashboardV2 = 'section-manager-dashboard-v2',
    SectionManagerAnalysisV2 = 'section-manager-analysis-v2',
    SectionManagerEmployeeActivities = 'section-manager-employee-activities',
    SectionManagerEmployeeDiscussions = 'section-manager-employee-discussions',
    SectionManagerEmployeeDiscussion = 'section-manager-employee-discussion',
    SectionManagerEmployeeTargets = 'section-manager-employee-targets',
    SectionManagerEmployeeAssessments = 'section-manager-employee-assessments',
    SectionManagerEmployeeDashboard = 'section-manager-employee-dashboard',

    // Administrator
    AdministratorCountryOverviewV2 = 'administrator-country-overview-v2',
    AdministratorGlobalOverviewV2 = 'administrator-global-overview-v2',
    AdministratorSettings = 'administrator-settings',
    AdministratorCostCenter = 'administrator-cost-center',
    AdministratorLegalEntity = 'administrator-legal-entity',
    AdministratorFile = 'administrator-file',
    AdministratorSettingsJobCluster = 'administrator-job-cluster',
    AdministratorSettingsJobFamilies = 'administrator-job-families',
    AdministratorSettingsJobArchitectureAccess = 'administrator-job-architecture-access',
    AdministratorSettingsJobArchitecture = 'administrator-settings-job-architecture',
    AdministratorCurrencyGroup = 'administrator-currency-group',
    AdministratorSalarySettings = 'administrator-salary-settings',
    AdministratorDiscussionDashboard = 'administrator-discussion-dashboard',
    AdministratorDiscussionOverview = 'administrator-discussion-overview',
    AdministratorDiscussionQuestionnaire = 'administrator-discussion-questionnaire',
    AdministratorCreateDiscussion = 'administrator-create-discussion',
    AdministratorExistingDiscussionEmployments = 'administrator-existing-discussion-employments',
    AdministratorAnalytics = 'administrator-analytics',
    AdministratorAnalyticsReport = 'administrator-analytics-report', // leave for now
    AdministratorAnalyticsDashboard = 'administrator-analytics-dashboard',
    AdministatorCreateEmployee = 'administrator-create-employee',
    AdministratorUnion = 'administrator-union',
    AdministratorWorks = 'administrator-works',
    AdministratorStatisticalCode = 'administrator-statistical-code',
    AdministratorQuestionTemplate = 'administrator-question-template',
    AdministratorCustomerInforfmation = 'administrator-customer-inforfmation',
    AdministratorGlobalPEASettings = 'administrator-global-pea-settings',
    AdministratorBaseRegistryEmployee = 'administrator-base-registry-employee',
    AdministratorBaseRegistryOrganization = 'administrator-base-registry-organisation',
    AdministratorBaseRegistryOrganizationDetails = 'administrator-base-registry-organisation-details',
    AdministratorBaseRegistryDetails = 'administrator-base-registry-details',
    AdministratorBaseRegistryCreateUser = 'administrator-base-registry-create-user',
    AdministratorBaseRegistryCreateEmployment = 'administrator-base-registry-create-employment',
    AdministratorFriends = 'administrator-friends',
    AdministratorInvolveSettings = 'administrator-involve-settings',
    AdministratorCountryEmployeePortal = 'administrator-country-employee-portal',
    AdministratorRoleAccess = 'administrator-role-access',
    AdministratorUserProvisioning = 'administrator-user-provisioning',
    AdministratorUserProvisioningGrid = 'administrator-user-provisioning-grid',
    AdministratorApiKeys = 'administrator-api-keys',
    AdministratorApiKeyDetail = 'administrator-api-key-detail',
    AdministratorWelcomeToSysarb = 'administrator-welcome-to-sysarb',
    AdministratorAgentChat = 'administrator-agent-chat',

    // Administrator-jobArchitecture
    AdministratorJobArchitectureManageEmploymentsV2 = 'administrator-job-architecture-manage-employments-v2',
    AdministratorJobArchitectureManageEmploymentsUnassigned = 'administrator-job-architecture-manage-employments-unassigned',
    AdministratorJobArchitectureManageEmploymentsAll = 'administrator-job-architecture-manage-employments-all',
    AdministratorJobArchitectureManageEmploymentsPublished = 'administrator-job-architecture-manage-employments-published',
    AdministratorJobArchitectureIntroduction = 'administrator-job-architecture-introduction',
    AdministratorJobArchitectureCreateJobProfiles = 'administrator-job-architecture-create-job-profiles',
    AdministratorJobArchitectureCreateJobProfile = 'administrator-job-architecture-create-job-profile',
    AdministratorJobArchitectureEvaluation = 'administrator-job-architecture-evaluation-v2',
    AdministratorJobArchitecturePayRanges = 'administrator-job-architecture-pay-ranges-v2',
    AdministratorJobArchitecturePayRangesV2 = 'administrator-job-architecture-pay-ranges-v3',
    AdministratorJobArchitecturePayRangesPublishedV2 = 'administrator-job-architecture-pay-ranges-published-v2',
    AdministratorJobArchitectureManageJobs = 'administrator-job-architecture-manage-jobs-v2',
    AdministratorJobArchitectureImport = 'administrator-job-architecture-import-v2', // special ts bs
    AdministratorJobArchitectureSelectType = 'administrator-job-architecture-select-type',
    AdministratorJobArchitectureOverview = 'administrator-job-architecture-overview',
    AdministratorJobArchitectureEmployeeCopilotOverviewV2 = 'administrator-job-architecture-employee-copilot-overview-v2',
    AdministratorJobArchitectureEmployeeCopilotSettingsOnCreateJobArchitecture = 'administrator-job-architecture-employee-copilot-settings-on-create-job-architecture',
    AdministratorJobArchitectureEmployeeCopilotSuggestionV2 = 'administrator-job-architecture-employee-copilot-suggestionV2',
    AdministratorJobArchitectureEmployeeCopilotNewlyHiredSuggestionsV2 = 'administrator-job-architecture-employee-copilot-newly-hired-suggestions-v2',
    AdministratorSettingsJobArchitectureCopilot = 'administrator-settings-job-architecture-copilot',

    // External job architecture
    AdministratorExternalJobArchitectureManageGrades = 'administrator-external-job-architecture-manage-grades',
    AdministratorExternalJobArchitectureOverview = 'administrator-external-job-architecture-overview',
    AdministratorExternalJobArchitecturePayRanges = 'administrator-external-job-architecture-pay-ranges',
    AdministratorExternalJobArchitecturePayRangeV2 = 'administrator-external-job-architecture-pay-ranges-v2',

    // Administrator-mappings
    AdministratorMappingPrepare = 'administrator-mapping-prepare',
    AdministratorMappingPrepareAdjustedSalary = 'administrator-mapping-prepare-adjusted-salary',
    AdministratorMappingAnalyzeEqualWorks = 'administrator-mapping-analyze-equal-works',
    AdministratorMappingAnalyzeEquivalentWorks = 'administrator-mapping-analyze-equivalent-works',
    AdministratorMappingAnalyzeEquivalentWorksV2 = 'administrator-mapping-analyze-equivalent-works-v2',
    AdministratorSecuritySettings = 'administrator-security-settings',
    AdministratorSalaryCriteriaTemplate = 'salary-criteria-template',
    AdministratorSSOSettings = 'administrator-sso-settings',

    // Administrator-pay-equity
    AdministratorPayEquityAuditDashboard = 'administrator-pay-equity-audit-dashboard',
    AdministratorPayEquityAuditOnboarding = 'administrator-pay-equity-audit-onboarding',
    AdministratorPayEquityAuditOverview = 'administrator-pay-equity-audit-overview',
    AdministratorPayEquityAuditReport = 'administrator-pay-equity-audit-report',
    AdministratorPayEquityAuditAnalyzeWorksV2 = 'administrator-pay-equity-audit-analyze-works-v2',
    AdministratorPayEquityAuditAnalyzeEqualJobsList = 'administrator-pay-equity-audit-analyze-works-list',
    AdministratorPayEquityAuditAnalyzeEquivalentWorks = 'administrator-pay-equity-audit-analyze-equivalent-works',
    AdministratorPayEquityAuditOrganizeGroup = 'administrator-pay-equity-audit-organize-group',
    AdministratorPayEquityAuditOrganizeWorkValuation = 'administrator-pay-equity-audit-organize-work-valuation',
    AdministratorPayPhilosophyModelInsights = 'administrator-pay-philosophy-model-insights',

    // Administrator-salary-import
    AdministratorDataImport = 'data-import',
    AdministratorSalaryImport = 'salary-file-import',
    AdministratorSalaryImportSettings = 'salary-import-settings',

    // Administrator integration
    AdministratorIntegrationOverview = 'administrator-integration-overview',
    AdministratorIntegrationSetup = 'administrator-integration-setup',
    AdministratorIntegrationPreview = 'administrator-integration-preview',
    AdministratorIntegrationValidation = 'administrator-integration-validation',
    AdministratorIntegrationList = 'administrator-integration-list',
    AdministratorIntegrationMatchFields = 'administrator-field-mappings',
    AdministratorIntegrationType = 'administrator-integration-type',

    // Administrator-salary-review
    AdministratorSalaryReviewDashboard = 'administrator-salary-review-dashboard',
    AdministratorSalaryReviewCritera = 'administrator-salary-review-criteria',
    AdministratorSalaryReviewBudget = 'administrator-salary-review-budget',
    AdministratorSalaryReviewOverview = 'administrator-salary-review-overview',
    AdministratorSalaryReviewResult = 'administrator-salary-review-result',
    AdministratorCreateSalaryReview = 'administrator-create-salary-review',
    AdministratorSalaryReviewEditEmployeeView = 'administrator-salary-review-edit-employee-view',
    AdministratorSalaryReviewResultEmployeeView = 'administrator-salary-review-result-employee-view',

    // Operational Administrator
    OperationalAdministratorCountryOverviewV2 = 'operational-administrator-country-overview-v2',
    OperationalAdministratorGlobalOverviewV2 = 'operational-administrator-global-overview-v2',
    OperationalAdministratorMappings = 'operational-administrator-mappings',
    OperationalAdministratorMappingPrepare = 'operational-administrator-mapping-prepare',
    OperationalAdministratorMappingPrepareAdjustedSalary = 'operational-administrator-mapping-prepare-adjusted-salary',
    OperationalAdministratorMappingAnalyzeEqualWorks = 'operational-administrator-mapping-analyze-equal-works',
    OperationalAdministratorMappingAnalyzeEquivalentWorks = 'operational-administrator-mapping-analyze-equivalent-works',
    OperationalAdministratorJobArchitectureOverview = 'operational-administrator-job-architecture-overview',
    OperationalAdministratorExternalJobArchitectureOverview = 'operational-administrator-external-job-architecture-overview',
    OperationalAdministratorWelcomeToSysarb = 'operational-administrator-welcome-to-sysarb',

    // Operational Administrator-pay-equity
    OperationalAdministratorPayEquityAuditDashboard = 'operational-administrator-pay-equity-audit-dashboard',
    OperationalAdministratorPayEquityAuditOnboarding = 'operational-administrator-pay-equity-audit-onboarding',
    OperationalAdministratorPayEquityAuditExport = 'operational-administrator-pay-equity-audit-export',
    OperationalAdministratorPayEquityAuditOrganizeGroup = 'operational-administrator-pay-equity-audit-organize-group',
    OperationalAdministratorPayEquityAuditOrganizeWorkValuation = 'operational-administrator-pay-equity-audit-organize-work-valuation',
    OperationalAdministratorPayEquityAuditAnalyzeEqualJobsList = 'operational-administrator-pay-equity-audit-analyze-equal-jobs-list',
    OperationalAdministratorPayEquityAuditAnalyzeWorksV2 = 'operational-administrator-pay-equity-audit-analyze-works-v2', // fix
    OperationalAdministratorPayEquityAuditAnalyzeEquivalentWorks = 'operational-administrator-pay-equity-audit-analyze-equivalent-works',
    OperationalAdministratorPayPhilosophyModelInsights = 'operational-administrator-pay-philosophy-model-insights',

    // Analyst
    AnalystCountryOverviewV2 = 'analyst-country-overview-v2',
    AnalystGlobalOverviewV2 = 'analyst-global-overview-v2',
    AnalystMappings = 'analyst-mappings',
    AnalystMappingAnalyzeEqualWorks = 'analyst-mapping-analyze-equal-works',
    AnalystMappingAnalyzeEquivalentWorks = 'analyst-mapping-analyze-equivalent-works',
    AnalystJobArchitectureOverview = 'analyst-job-architecture-overview',
    AnalystExternalJobArchitectureOverview = 'analyst-external-job-architecture-overview',
    AnalystWelcomeToSysarb = 'analyst-welcome-to-sysarb',

    // Analyst-pay-equity
    AnalystPayEquityAuditOrganizeGroup = 'analyst-pay-equity-audit-organize-group',
    AnalystPayEquityAuditDashboard = 'analyst-pay-equity-audit-dashboard',
    AnalystPayEquityAuditAnalyzeEqualJobsList = 'analyst-pay-equity-audit-analyze-equal-jobs-list',
    AnalystPayEquityAuditAnalyzeWorksV2 = 'analyst-pay-equity-audit-analyze-works-v2', // leave for now
    AnalystPayEquityAuditAnalyzeEquivalentWorks = 'analyst-pay-equity-audit-analyze-equivalent-works',

    // Readonly
    ReadOnlyGlobalOverviewV2 = 'readOnly-global-overview-v2',
    ReadOnlyCountryOverviewV2 = 'readOnly-country-overview-v2',
    ReadOnlyMappings = 'readOnly-mappings',
    ReadOnlyMappingOrganizeWorkValuation = 'readOnly-mapping-organize-work-valuation',
    ReadOnlyMappingAnalyzeEqualWorks = 'readOnly-mapping-analyze-equal-works',
    ReadOnlyMappingAnalyzeEquivalentWorks = 'readOnly-mapping-analyze-equivalent-works',
    ReadOnlyJobArchitectureOverview = 'readOnly-job-architecture-overview',
    ReadOnlyExternalJobArchitectureOverview = 'readOnly-external-job-architecture-overview',
    ReadOnlyWelcomeToSysarb = 'readOnly-welcome-to-sysarb',

    // Readonly-pay-equity
    ReadOnlyPayEquityAuditOrganizeWorkValuation = 'readOnly-pay-equity-audit-organize-work-valuation',
    ReadOnlyPayEquityAuditDashboard = 'read-only-pay-equity-audit-dashboard',
    ReadOnlyPayEquityAuditAnalyzeEqualJobsList = 'read-only-pay-equity-audit-analyze-equal-jobs-list',
    ReadOnlyPayEquityAuditAnalyzeWorksV2 = 'read-only-pay-equity-audit-analyze-works-v2',
    ReadOnlyPayEquityAuditAnalyzeEquivalentWorks = 'read-only-pay-equity-audit-analyze-equivalent-works',

    // Union
    UnionStart = 'union-start',
    UnionSalarySetDashboard = 'union-salary-set-dashboard',
    UnionSalarySet = 'union-salary-set',
    UnionJobArchitectureOverview = 'union-job-architecture-overview',
    UnionExternalJobArchitectureOverview = 'union-external-job-architecture-overview',

    AdministratorIntegrationFilter = 'administrator-integration-filter',
}
